import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-staff',
  templateUrl: './admin-staff.component.html',
  styleUrls: ['./admin-staff.component.scss'],
  standalone: false,
})
export class AdminStaffComponent {
  benifits = [
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/administration-image-1.png',
      heading: 'Simplify Administrative Workflows',
      number: '01',
      description: 'Automate daily tasks to save time and reduce paperwork.',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/administration-image-2.png',
      heading: 'Real-Time Financial Management',
      number: '02',
      description: 'Automate daily tasks to save time and reduce paperwork.',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/administration-image-3.png',
      heading: 'Enhanced Communication Channels',
      number: '03',
      description:
        'Connect effortlessly with staff, students, and parents through integrated messaging.',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/administration-image-4.png',
      heading: 'Secure Data & Access Control',
      number: '04',
      description:
        'Protect sensitive information with advanced security and customizable permissions.',
    },
  ];
}
